import React, { useEffect, useState } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../../services/helpers';
import { httpRequest } from '../../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../../parts/Loader';
import store from '../../../../services/store';
import images from '../../../../services/images';
import initTreeView from '../../../../services/initTreeView';
import StoreInfo from '../../../parts/StoreInfo';
import { getApiData } from '../../../../services/apiService';
import { serviceRequestData } from '../../../../services/serviceHubStore';

export default function SchedulesManifestPrintView (){
    const { schedule_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState([]);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [load_status, setStatus] = useState(0);
    const [account, setAccount] = useState([]);
   
    useEffect(() => {
        initTreeView()
        
        //const customer_id = helpers.getURLParams('customer_id');
        //const request_from = helpers.getURLParams('request_from');
        //const request_to = helpers.getURLParams('request_to');
        //if(customer_id && request_from && request_to){
            fetchAccount()
        //}
    }, []);

    useEffect(() => {
        if(load_status){
            setTimeout(function(){
                //window.print()
            }, 2000);
        }
    }, [load_status]);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    async function fetchAccount(){
        let endpoint = helpers.createUrl(`V1/account/profile`)
        const res = await getApiData(endpoint)

        if(res){
            setAccount(res.data)
            fetchData()
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/customers/list");
                }
            })
        }
    }

    async function fetchData(){
        //const endpoint = helpers.createShipBookingHubUrl(`voyage/${schedule_id}/manifest`)
        const endpoint = helpers.createShipBookingHubUrl(`voyage/${schedule_id}`)

        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            setRecordData(res)
            setRecordItems(res.items)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/customers/list");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                let counter = parseInt(key) + 1
                return(
                    <>
                        <tr>
                            <td>{counter}</td>
                            <td>{data?.booking_ref ? data.booking_ref : 'N/A'}</td>
                            <td>{data?.plate_number ? data.plate_number : 'N/A'}</td>
                            {/* <td>1 unit</td> */}
                            <td>{`${data?.brand} | ${data?.model_name}`}</td>
                            <td>{data?.customer_name ? data.customer_name : 'N/A'}</td>
                            <td>{data?.driver ? data.driver : 'N/A'}</td>
                        </tr>
                    
                        <tr>
                        </tr>
                    </>
                )
            })

            items.push(
                <tr>
                    <th className='bg-light' colSpan={7}>
                        Total Unit Count: 
                        <span className='font-weight-normal ml-1'> {record_items?.length} {record_items?.length > 1 ? ' units' : ' unit'}</span>
                    </th>
                </tr>
            )
        }
        else{
            items =  
                    <tr>
                        <td colSpan={10} className='text-center'>No data to display.</td>
                    </tr>
        }


        setTableItems(<tbody>{items}</tbody>)
        setStatus(1)
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatCurrencyAmount(total_amount);
    }


    function getCurrentDateTime() {
        const now = new Date();

        // 1. Format the Date: "14 May 2026"
        const datePart = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(now);

        // 2. Format the Time: "02:28:31PM"
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).format(now).replace(/\s/g, '');

        // 3. Combine with a comma
        return `${datePart}, ${timePart}`;
    }

    function formatManifestDateTime(inputString) {
        // Replace the space with 'T' to ensure cross-browser compatibility
        const date = new Date(inputString.replace(' ', 'T'));

        // Format Date: 16 May 2026
        const datePart = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(date);

        // Format Time: 7:00PM
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(date).replace(/\s/g, '');

        return `${datePart}, ${timePart}`;
    }

    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>

            
            <div className="mx-auto d-flexs justify-content-betweens">
                {/* <img src={images.main_logo} height={80} className='float-left mr-3' /> */}
                <div>
                    <p className='mb-0'><b>San Ricardo Shipping Line</b></p>
                    <p className='mb-0' style={{fontSize: '14px'}}>Unit 3, Port Area Commercial Center, Brgy. Benit, San Ricardo, Southern Leyte 6617</p>
                    <p className='mb-0' style={{fontSize: '14px'}}>0953-685-7478</p>
                </div>
            </div>

            <hr/>
            
            <h5 className='text-center'><strong>DOMESTIC CARGO MANIFEST</strong></h5>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    <p className='mb-0'>Vessel Name: <b>{record_data?.ship_name ? record_data?.ship_name : 'N/A'}</b></p>
                    <p className='mb-0'>Registry No: <b>{record_data?.registry_no ? record_data?.registry_no : 'N/A'}</b></p>
                    <p className='mb-0'>Voyage Number: <b>{record_data?.voyage_no ? record_data?.voyage_no : 'N/A'}</b></p>
                    <p className='mb-0'>Gross Tonnage: <b>{record_data?.customer?.contact_name ? record_data?.customer?.contact_name : 'N/A'}</b></p>
                    {/* <p>Service Date: <b>{`${helpers.getURLParams('request_from')} to ${helpers.getURLParams('request_to')}`}</b></p> */}
                </div>
                <div>
                    <p className='mb-0'>Generated Date: <b>{getCurrentDateTime()}</b></p>
                    <p className='mb-0'>Origin: <b>{record_data?.origin ? record_data?.origin : 'N/A'}</b></p>
                    <p className='mb-0'>Destination: <b>{record_data?.destination ? record_data?.destination : 'N/A'}</b></p>
                    <p className='mb-0'>Departure Date/Time: <b>{record_data?.start ? formatManifestDateTime(record_data?.start) : 'N/A'}</b></p>
                </div>
            </div>

            <div className='table-responsives mb-2'>
                <table className='table table-bordered table-stripeds table-sm border-bottom mb-0'>
                    <thead class="thead-dark">
                        <tr>
                            <th>No.</th>
                            <th>Booking No.</th>
                            <th>Plate No.</th>
                            <th>Vehicle Description</th>
                            <th>Owner/Consignee</th>
                            <th>Driver Name(s)</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>
            <hr/>
            <div className='mb-4'>
                <h5><strong>DECLARATION & ATTESTATION</strong></h5>
                <p className='font-weight-bold mb-0'>CERTIFICATION:</p>
                <p style={{fontSize: '14px'}}>I hereby certify that the above-described vehicle cargo has been duly received and loaded onboard the named vessel. This manifest is a true and accurate record of all units currently on the car deck for the specified voyage.</p>
            </div>
            <div className="row mt-3">
                <div className="col-3">
                    <p className='font-weight-bold mb-0'>Prepared By:</p>
                    <div className="cards">
                        <table className='table border-0'>
                            <tr>
                                <td className='border-top-0' style={{height: '100px'}}>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Cargo Encoder/Clerk</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div className="col-1"></div>
                <div className="col-3">
                    <p className='font-weight-bold mb-0'>Verified By:</p>
                    <div className="cards">
                        <table className='table border-0'>
                            <tr>
                                <td className='border-top-0' style={{height: '100px'}}>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Chief Officer</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div className="col-1"></div>
                <div className="col-3">
                    <p className='font-weight-bold mb-0'>Certified Correct:</p>
                    <div className="cards">
                        <table className='table border-0'>
                            <tr>
                                <td className='border-top-0' style={{height: '100px'}}>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Master (Captain)</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            {/* <div className="d-flex justify-content-between mb-3">
                <div>
                    <p className='mb-0'>TOTAL VEHICLE UNITS ON BOARD: <b>{record_data?.customer?.contact_name ? record_data?.customer?.contact_name : 'N/A'}</b></p>
                </div>
                <div>
                </div>
            </div> */}

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>This is a system-generated report. Powered by Topventory One.</small>
                </div>
            </div>
        </div>
    )
}